// 培训平台路由
export default [
  // 首页路由重定向
  {
    path: "/",
    redirect: "/train/home"
  },
  // 首页
  {
    path: "/train/home",
    name: "home",
    component: () => import("@/pages_train/home/index")
  },
  // 论坛列表
  {
    path: "/train/forum",
    name: "forum",
    redirect: "/train/forum/fourmCommunity",
    component: () => import("@/pages_train/forum/index"),
    children: [
      {
        path: "/train/forum/fourmCommunity",
        name: "fourmCommunity",
        component: () => import("@/pages_train/forum/fourmCommunity")
      },
      {
        path: "/train/forum/list",
        name: "forumList",
        component: () => import("@/pages_train/forum/list")
      },
      {
        path: "/train/forum/createForum",
        name: "createForum",
        component: () => import("@/pages_train/forum/createForum")
      }
    ]
  },
  // 直播课程
  {
    path: "/train/moreLive",
    name: "moreLive",
    component: () => import("@/pages_train/moreLive/index"),
    meta: {
      name: "moreLive"
    }
  },
  // 视频课程
  {
    path: "/train/course",
    name: "course",
    component: () => import("@/pages_train/course/index"),
    meta: {
      name: "course"
    }
  },
  // 视频课程详情
  {
    path: "/train/courseDetail",
    name: "courseDetail",
    component: () => import("@/pages_train/courseDetail/index"),
    meta: {
      name: "courseDetail"
    }
  },
  // 更多学习概况
  {
    path: "/train/moreStudy",
    name: "moreStudy",
    component: () => import("@/pages_train/moreStudy/index"),
    meta: {
      name: "moreStudy"
    }
  },
  // 直播回放
  {
    path: "/train/replayLive",
    name: "replayLive",
    component: () => import("@/pages_train/replayLive/index"),
    meta: {
      name: "replayLive"
    }
  },
  // 视频学习
  {
    path: "/train/videoPlay",
    name: "videoPlay",
    component: () => import("@/pages_train/videoPlay/index"),
    meta: {
      name: "videoPlay"
    }
  },
  {
    path: "/train/videoPlayThird",
    name: "videoPlayThird",
    component: () => import("@/pages_train/videoPlayThird/index"),
    meta: {
      title: "视频播放"
    }
  },
  // 随堂练习
  {
    path: "/train/doWork",
    name: "doWork",
    component: () => import("@/pages_train/doWork/index"),
    meta: {
      name: "doWork"
    }
  },
  // 随堂练习详情
  {
    path: "/train/answerResult",
    name: "answerResult",
    component: () => import("@/pages_train/answerResult/index"),
    meta: {
      name: "answerResult"
    }
  },
  // 答案解析
  {
    path: "/train/readAnswer",
    name: "readAnswer",
    component: () => import("@/pages_train/readAnswer/index"),
    meta: {
      name: "readAnswer"
    }
  },
  // 错题集
  {
    path: "/train/readWrongAnswer",
    name: "readWrongAnswer",
    component: () => import("@/pages_train/readWrongAnswer/index"),
    meta: {
      name: "readWrongAnswer"
    }
  },
  {
    path: "/train/degree",
    name: "degree",
    component: () => import("@/pages_train/degree/index"),
    meta: {
      name: "degree"
    }
  },
  {
    path: "/train/degreeInfo",
    name: "degreeInfo",
    component: () => import("@/pages_train/degreeInfo/index"),
    meta: {
      name: "degreeInfo"
    }
  },
  // 直播页面
  {
    path: "/train/livePage",
    name: "livePage",
    component: () => import("@/pages_train/livePage/index"),
    meta: {
      name: "livePage"
    }
  },
  // 文档学习
  {
    path: "/train/readDoc",
    name: "readDoc",
    component: () => import("@/pages_train/readDoc/index"),
    meta: {
      name: "readDoc"
    }
  },
  // PDF
  {
    path: "/train/readPdf",
    name: "readPdf",
    component: () => import("@/pages_train/readPdf/index"),
    meta: {
      name: "readPdf"
    }
  },
  // 作业
  {
    path: "/train/homeWork",
    name: "homeWork",
    component: () => import("@/pages_train/homeWork/index"),
    meta: {
      name: "homeWork"
    }
  },
  // 我的学籍
  {
    path: "/train/myRoll",
    name: "myRoll",
    component: () => import("@/pages_train/myRoll/index"),
    meta: {
      name: "myRoll"
    }
  },
  // 培训班级
  {
    path: "/train/trainClasses",
    name: "trainClasses",
    component: () => import("@/pages_train/trainClasses/index"),
    meta: {
      name: "trainClasses"
    }
  },
  // 意见及建议
  {
    path: "/train/suggestion",
    name: "suggestion",
    component: () => import("@/pages_train/suggestion/index"),
    meta: {
      name: "trainClasses"
    }
  },
  // 班级详情
  {
    path: "/train/classInfo",
    name: "classInfo",
    component: () => import("@/pages_train/classInfo/index"),
    meta: {
      name: "trainClasses"
    }
  },
  // 通讯录
  {
    path: "/train/addressList",
    name: "addressList",
    component: () => import("@/pages_train/addressList/index"),
    meta: {
      name: "trainClasses"
    }
  },
  // 项目通知
  {
    path: "/train/projectNotice",
    name: "projectNotice",
    component: () => import("@/pages_train/projectNotice/index"),
    meta: {
      name: "projectNotice"
    }
  },
  // 培训证书
  {
    path: "/train/cert",
    name: "cert",
    component: () => import("@/pages_train/cert/index"),
    meta: {
      name: "cert"
    }
  },
  // 我的成绩
  {
    path: "/train/myGrade",
    name: "myGrade",
    component: () => import("@/pages_train/myGrade/index"),
    meta: {
      name: "myGrade"
    }
  },
  // 我的提问
  {
    path: "/train/myAsk",
    name: "myAsk",
    component: () => import("@/pages_train/myAsk/index"),
    meta: {
      name: "myAsk"
    }
  },
  // 直播回放
  {
    path: "/train/playBack",
    name: "playBack",
    component: () => import("@/pages_train/playBack/index"),
    meta: {
      name: "playBack"
    }
  },
  // 我的考勤
  {
    path: "/train/myAttendance",
    name: "myAttendance",
    component: () => import("@/pages_train/myAttendance/index"),
    meta: {
      name: "myAttendance"
    }
  },
  // 学习记录
  {
    path: "/train/myStudy",
    name: "myStudy",
    component: () => import("@/pages_train/myStudy/index"),
    meta: {
      name: "myStudy"
    }
  },
  // 我的课表
  {
    path: "/train/myCourseForm",
    name: "myCourseForm",
    component: () => import("@/pages_train/myCourseForm/index"),
    meta: {
      name: "myCourseForm"
    }
  },
  // 我的论坛
  {
    path: "/train/myForum",
    name: "myForum",
    component: () => import("@/pages_train/forum/myForum"),
    meta: {
      name: "myForum"
    }
  },
  {
    path: "/train/moreThesisSupervision",
    name: "moreThesisSupervision",
    component: () => import("@/pages_train/moreThesisSupervision/index"),
    meta: {
      title: "论文指导"
    }
  },
  {
    path: "/train/playThesis",
    name: "playThesis",
    component: () => import("@/pages_train/playThesis/index"),
    meta: {
      title: "论文指导"
    }
  },
  {
    path: "/train/thesis",
    name: "thesis",
    component: () => import("@/pages_train/thesis/index"),
    meta: {
      name: "thesis"
    }
  },
  {
    path: "/train/thesisList",
    name: "thesisList",
    component: () => import("@/pages_train/thesisList/index"),
    meta: {
      name: "thesisList"
    }
  },
  {
    path: "/train/thesisInfo",
    name: "thesisInfo",
    component: () => import("@/pages_train/thesisInfo/index"),
    meta: {
      name: "thesisInfo"
    }
  },
  // 我的申诉
  {
    path: "/train/myAppeal",
    name: "myAppeal",
    component: () => import("@/pages_train/myAppeal/index"),
    meta: {
      name: "myAppeal"
    }
  },
  // 在线考试
  {
    path: "/train/onlineExamination",
    name: "onlineExamination",
    component: () => import("@/pages_train/onlineExamination/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 学籍卡
  {
    path: "/train/rollCard",
    name: "rollCard",
    component: () => import("@/pages_train/rollCard/index"),
    meta: {
      name: "rollCard"
    }
  },
  // 考试答题
  {
    path: "/train/onlineExaming",
    name: "onlineExaming",
    component: () => import("@/pages_train/onlineExaming/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 答题情况
  {
    path: "/train/onlineExamInfo",
    name: "onlineExamInfo",
    component: () => import("@/pages_train/onlineExamInfo/index"),
    meta: {
      name: "onlineExamination"
    }
  },
  // 线上签到
  {
    path: "/train/onlineSign",
    name: "onlineSign",
    component: () => import("@/pages_train/onlineSign/index"),
    meta: {
      name: "onlineSign"
    }
  },
  // 线上签到记录
  {
    path: "/train/signRecord",
    name: "signRecord",
    component: () => import("@/pages_train/signRecord/index"),
    meta: {
      name: "onlineSign"
    }
  },
  // 作业
  {
    path: "/homeWork",
    name: "homeWork",
    component: () => import("@/pages/homeWork/index"),
    meta: {
      name: "homeWork"
    }
  },
  // 问卷调查
  {
    path: "/train/ask",
    name: "ask",
    component: () => import("@/pages_train/ask/index"),
    meta: {
      name: "ask"
    }
  },
  // 问卷调查详情
  {
    path: "/train/askInfo",
    name: "askInfo",
    component: () => import("@/pages_train/askInfo/index"),
    meta: {
      name: "ask"
    }
  },
  // 教学质量评价
  {
    path: "/train/teachEvaluate",
    name: "teachEvaluate",
    component: () => import("@/pages_train/teachEvaluate/index"),
    meta: {
      name: "teachEvaluate"
    }
  },
  {
    path: "/train/teachEvaluateInfo",
    name: "teachEvaluateInfo",
    component: () => import("@/pages_train/teachEvaluateInfo/index"),
    meta: {
      name: "teachEvaluate"
    }
  },
  // 我的收件箱
  {
    path: "/train/myMsg",
    name: "myMsg",
    component: () => import("@/pages_train/myMsg/index"),
    meta: {
      name: "myMsg"
    }
  },
  // 教学计划课程
  {
    path: "/train/myPlanCourse",
    name: "myPlanCourse",
    component: () => import("@/pages_train/myPlanCourse/index"),
    meta: {
      name: "myPlanCourse"
    }
  },
  // 意见反馈
  {
    path: "/train/myFeedback",
    name: "myFeedback",
    component: () => import("@/pages_train/myFeedback/index"),
    meta: {
      name: "myFeedback"
    }
  },
  // 常见问题
  {
    path: "/train/question",
    name: "question",
    component: () => import("@/pages_train/question/index"),
    meta: {
      name: "question"
    }
  },
  // 网站公告列表
  {
    path: "/train/notice",
    name: "notice",
    component: () => import("@/pages_train/notice/index")
  },
  // 账号管理
  {
    path: "/train/account",
    name: "account",
    component: () => import("@/pages_train/account/index"),
    meta: {
      name: "account"
    }
  },
  // 联系我们
  {
    path: "/train/contactUs",
    name: "contactUs",
    component: () => import("@/pages_train/contactUs/index"),
    meta: {
      name: "contactUs"
    }
  },
  // 电子签名预览
  {
    path: "/train/signaturePreview",
    name: "signaturePreview",
    component: () => import("@/pages/signaturePreview/index"),
    meta: {
      name: "signaturePreview"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/train.js